// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oCqDH","newExpiryDate":"styles_newExpiryDate__2zg8K","footer":"styles_footer__3F0bE"};